const StockReports = () => import("./stock-reports.vue");

export default [
    {
      path: "/stock-reports",
      component: StockReports,
    },
]

